import LanguageDetector from "i18next-browser-languagedetector";
import { languages } from "@excalidraw/excalidraw";

export const languageDetector = new LanguageDetector();

languageDetector.init(
  { languageUtils: {} },
  {
    // mokli: only honor an explicitly stored choice (written by
    // cacheUserLanguage when the user picks a language in the menu).
    // No navigator/querystring detection — everything else defaults to
    // Lithuanian below.
    order: ["localStorage"],
    caches: ["localStorage"],
  },
);

export const getPreferredLanguage = () => {
  const detectedLanguages = languageDetector.detect();

  const detectedLanguage = Array.isArray(detectedLanguages)
    ? detectedLanguages[0]
    : detectedLanguages;

  const initialLanguage =
    (detectedLanguage
      ? // region code may not be defined if user uses generic preferred language
        // (e.g. chinese vs instead of chinese-simplified)
        languages.find((lang) => lang.code.startsWith(detectedLanguage))?.code
      : null) || "lt-LT";

  return initialLanguage;
};
